import { JSX } from 'react';
import taiwanIcon from '../../assets/images/icons/taiwan.png';
import usaIcon from '../../assets/images/icons/burger.png';
import rainbowIcon from '../../assets/images/icons/rainbow.png';
import workIcon from '../../assets/images/icons/tobacco.png';
import hyteIcon from '../../assets/images/icons/packaging.png';
import CheckBox from '../../home-page/preview/checkBox/checkBox';
import { CalendarId } from '../../services/calendarService';
import './calendarPickerItem.css';

interface CalendarPickerItemProps {
    selected: boolean;
    onSelectedChange: () => void;
    calendarId: CalendarId;
}

const getCalendarIcon = (calendarId: CalendarId): string => {
    switch (calendarId) {
        case 'taiwan holiday': return taiwanIcon;
        case 'us holiday': return usaIcon;
        case 'work': return workIcon;
        case 'HYTE': return hyteIcon;
        default: return rainbowIcon;
    }
}
const CalendarPickerItem = ({ selected, onSelectedChange, calendarId }: CalendarPickerItemProps): JSX.Element => {
    return (
        <div className='calendar-picker-item'>
            <CheckBox isCompleted={selected} onCompleteChange={onSelectedChange}/>
                <p>{calendarId}</p>
            <img src={getCalendarIcon(calendarId)} alt='calendar-icon' className='calendar-picker-item-icon'/>
        </div>
    );
};

export default CalendarPickerItem;
